<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:30%" label="姓名" type="text" id="name"
                                    :modelValue="form.name" placeholder="请输入姓名"
                                    @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                        />
                        <SelectField label="类型" labelWidth="30%" id="type" style="margin: 0.5rem 0.2rem;width:30%"
                                     :modelValue="form.type" :options="menuTypeList"
                                     @update:modelValue="(value) => handleModelValueUpdate('type', value)"
                        />
                        <SelectField label="状态" labelWidth="30%" id="status" style="margin: 0.5rem 0.2rem;width:30%"
                                     :modelValue="form.status" :options="statusList"
                                     @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                        />
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="新增" primary @click="add"/>
                    </div>
                </div>
            </form>
        </div>
        <a-table
            bordered
            :dataSource="list"
            :loading="loading"
            :pagination="false"
            rowKey="id"
        >
            <a-table-column title="名称" data-index="name"></a-table-column>
            <a-table-column title="路径" data-index="path"></a-table-column>
            <a-table-column title="关联权限" data-index="permission">
                <template slot-scope="permission">
                    {{ permissionRender(permission) }}
                </template>
            </a-table-column>

            <a-table-column title="类型" align="center">
                <template slot-scope="text">
                    <DataDictFinder dictType="menuType" :dictValue="text.type" />
                </template>
            </a-table-column>
            <a-table-column title="状态" align="center">
                <template slot-scope="text">
                    <DataDictFinder
                        dictType="status"
                        :dictValue="String(text.status)"
                    />
                </template>
            </a-table-column>
            <a-table-column title="排序" data-index="sort"></a-table-column>
            <a-table-column title="备注" data-index="remarks"></a-table-column>

            <a-table-column title="操作" align="center">
                <template slot-scope="text">
                    <a-space>
                        <a @click.prevent="edit(text)">编辑</a>
                        <a class="danger" @click.prevent="deleteText(text)">删除</a>
                    </a-space>
                </template>
            </a-table-column>
        </a-table>
    </div>
</template>

<script>
import { fetchList as fetchPermissionList } from "@/api/setting/permission";
import { fetchList, remove } from "@/api/setting/menu";
import { mapGetters } from "vuex";
import { buildMenuTree } from "./tools";
export default {
  data() {
    return {
      form: {},
      permissionList: [],
      loading: false,
      list: [],
      addShow:false,editShow:false,
      visible: false,
      tableColumns: [
        {
            key: 'name',
            title: '姓名',
            field: 'name',
            infotype: 'text'
        },
        {
            key: 'path',
            title: '路径',
            field: 'path',
            infotype: 'text',
        },
        {
            key: 'permission',
            title: '关联权限',
            field: 'permission',
            infotype: 'template'
        },
        {
            key: 'type',
            title: '类型',
            field: 'type',
            infotype: 'template',
        },
        {
            key: 'status',
            title: '状态',
            field: 'status',
            infotype: 'template',
        },
        {
            key: 'sort',
            title: '排序',
            field: 'sort',
            infotype: 'text',
        },
        {
            key: 'remarks',
            title: '备注',
            field: 'remarks',
            infotype: 'text',
        },
        {
            key: 'actions',
            title: '操作',
            infotype: 'template',
        }
    ],
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("status");
    },
    menuTypeList() {
      return this.findDataDict("menuType");
    },
  },

  mounted() {
    fetchPermissionList({
      pageNum: 1,
      pageSize: 1000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.permissionList = Object.freeze(res.list);
      }
    });

    this.getList();
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
      handleAction(actionInfo){
          const { type, item } = actionInfo;
          switch(type) {
              case 'edit':
                  this.editText(item);
                  break;
              case 'delete':
                  this.deleteText(item);
                  break;
          }
      },
      add(){
          this.$router.push("/setting/menu/add");
      },
    getList() {
      this.loading = true;
      fetchList({
        ...this.form,
      })
        .then((res) => {
          if (Array.isArray(res)) {
            this.list = Object.freeze(buildMenuTree(res, "0"));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },

    query() {
      this.getList();
    },
    reset() {
      this.form = {};
      this.getList();
    },

    edit(text) {
      window.localStorage.setItem("menu-detail", JSON.stringify(text));
      this.$router.push("/setting/menu/edit");
    },

    permissionRender(permission) {
      console.log("Permission Code:", permission);
      const res = this.permissionList.find((item) => item.code === permission);
      console.log("res::::",res)
      if (res) {
        return res.name;
      } else {
        return "--";
      }
    },
  },
};
</script>


<style lang="less" scoped>
::v-deep .ant-table-bordered .ant-table-thead > tr > th,::v-deep .ant-table-bordered .ant-table-tbody > tr > td{
    border:none;
    color: #adadad;
    padding: 1rem;
}
::v-deep .ant-table-bordered .ant-table-thead > tr > th{
    border-bottom: 1px solid #00ff96;
}
::v-deep .ant-table-bordered .ant-table-header > table,
::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table{
    border: none;
}
::v-deep .ant-table-thead > tr > th{
    background: rgba(10, 20, 40, 0.6);
    color: #adadad;
}
::v-deep .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
    background: rgba(0,255,150,0.1);
}

.logQuery{
    display: flex;
    justify-content: start;
    width: 80%;
}
::v-deep .input-container{
    padding: 0;
}
.selector {
  position: fixed;
  top: 11vh;
  left: 17vw;
  right: calc(1vw + 140px);
  z-index: 99;
  background-color: var(--bg-color);

  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;

  & > .header {
    background-color: var(--theme-color);
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .query {
    padding: 2vh 1vw 0;
  }
  .table {
    padding: 2vh 1vw;
  }
}
</style>
